import { useState } from "react";

import GridMoreVertIcon from "@mui/icons-material/MoreVert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { usersText } from "../../assets/texts/IAM/users";
import { type UserRow } from "../../types/User";

type UserThreeDotMenuProps = {
  userRow: UserRow;
  onEdit: (userRowId: string) => void;
  onDelete: (row: UserRow) => void;
};

export const UserThreeDotMenu = ({ userRow, onEdit, onDelete }: UserThreeDotMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit(userRow.id);
    handleClose();
  };

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
    handleClose();
  };

  const handleDeleteConfirm = () => {
    onDelete(userRow);
    setIsDeleteModalOpen(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick} data-cy={`user-row-actions-${userRow.id}`}>
        <GridMoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} data-cy={`user-row-menu-${userRow.id}`}>
        <MenuItem onClick={handleEdit} data-cy={`user-row-edit-${userRow.id}`}>
          {usersText.EDIT_USER}
        </MenuItem>
        <MenuItem onClick={handleDeleteClick} data-cy={`user-row-delete-${userRow.id}`} sx={{ color: "error.main" }}>
          {usersText.DELETE_USER}
        </MenuItem>
      </Menu>

      <Dialog open={isDeleteModalOpen} onClose={handleDeleteCancel} data-cy={`user-delete-confirmation-${userRow.id}`}>
        <DialogTitle>{usersText.DELETE_USER}</DialogTitle>
        <DialogContent>
          <DialogContentText>{usersText.DELETE_USER_WARNING(userRow.email)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} data-cy={`user-delete-cancel-${userRow.id}`}>
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" data-cy={`user-delete-confirm-${userRow.id}`}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
